import { Injectable, Inject } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { ActionTypes, Actions } from '../../store/cabinets/cabinets.actions';
import { StateInterface } from '../../store/state.model';
import { HeadersHelper, ItemsHelper } from '../../helpers';
import { _, tassign, getState } from '../../tools';

import 'rxjs/Rx';

@Injectable()

/**
 * Class representing the Cabinets service.
 */
export class CabinetsService {

	/**
	 * Constructor.
	 * @param {string} apiEndPoint
	 * @param {Http} http
	 * @param {Store} store
	 * @return {void}
	 */
	constructor(
		@Inject('ApiEndpoint') private apiEndpoint: string,
		private http: Http,
		private store: Store<StateInterface>) {
	}

	/**
	 * Retrieve cabinets data from server and dispatch action
	 * to update the store accordingly.
	 * @return {Observable}
	 */
	hydrateCabinets(): Observable<Response> {
		this.store.dispatch(this.setIsLoading(true));
		return this.http
			.get(`${this.apiEndpoint}cabinet`, HeadersHelper.getOptions(this.store));
	}

	/**
	 * Dispatch an action to load cabinets.
	 * @param {object} result
	 * @return  {Actions}
	 */
	loadCabinets(result: any): Actions {
		const { cabinets } = getState(this.store);

		return {
			type: ActionTypes.LOAD_CABINETS,
			payload: tassign(cabinets, {
				items: ItemsHelper.mapCabinetItems(result),
				isLoading: false
			})
		};
	}

	/**
	 * Dispatch an action to reset the entire state.
	 * @return  {Actions}
	 */
	resetState(): Actions {
		return {
			type: ActionTypes.RESET_STATE
		};
	}

	/**
	 * Dispatch an action to change the state for 'isLoading'.
	 * @param {boolean} to - The new state
	 * @return  {Actions}
	 */
	setIsLoading(to: boolean): Actions {
		return {
			type: ActionTypes.SET_IS_LOADING,
			payload: to
		};
	}
}